import { Box, Link, Text } from "@chakra-ui/react"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { Link as ReactRouterLink } from "react-router-dom"
import { PATHWRIGHT_SCHOOL_ID } from "../../lib/core/constants"

function CreateSpacePrompt() {
  const { school } = usePathwrightContext()

  return school.id === PATHWRIGHT_SCHOOL_ID ? (
    <Box
      className="GlobalAuth__create-space-prompt"
      display="none"
      sx={{
        // Prevents displaying the prompt unitl the auth flow has rendered.
        [".GlobalAuth__wrapper:has(.AdaptedAuthContainer) &"]: {
          display: "block"
        }
      }}
    >
      <Text textAlign="center">
        Don’t have a Learning Space yet?{" "}
        <Link as={ReactRouterLink} to="/sign-up/" textDecor="underline">
          Create one
        </Link>
        .
      </Text>
    </Box>
  ) : null
}

export default CreateSpacePrompt
